const $ = (window as any).jQuery as JQueryStatic;

import './theme.js';

import entryVideo from './entryVideo';
entryVideo('.custom-discovery-video');

import tabs from './Tabs';
tabs();

import './qualifyFreeShipping';

import ContactForm from './ContactForm';
ContactForm();

// Workaround for /?ps-open causing page reload
var priceSpiderWidget = document.querySelector('.ps-widget');
if (priceSpiderWidget) {
	document.addEventListener('click', function(event) {
		var target = event.target;
		//@ts-ignore TODO
		if (target.hasAttribute('href') && target.href.includes('?ps-open')) {
			event.preventDefault();
			//@ts-ignore TODO
			priceSpiderWidget.click();
		}
	});
}

// Find in Store CTA (product page) - update text
var productContent = document.querySelector('.product-single');
if (productContent) {
	// This is a hack, but more simple than appending stuff to div.ps-widget and preventing it from getting wiped out
	var findInStoreHeadingValue = productContent.getAttribute('data-find-in-store-cta-heading');
	if (findInStoreHeadingValue) {
		var styleElement = document.createElement('style');
		styleElement.textContent = '.findInStoreCTA .ps-widget::before { content: "' + findInStoreHeadingValue + '"; }';
		document.head.appendChild(styleElement);
	}

	var findInStoreTextValue = productContent.getAttribute('data-find-in-store-cta-text');
	if (findInStoreTextValue) {
		var styleElement = document.createElement('style');
		styleElement.textContent = '.findInStoreCTA .ps-widget::after { content: "' + findInStoreTextValue + '"; }';
		document.head.appendChild(styleElement);
	}
}


// This is copied from the old site
//@ts-ignore
$(".products-carousel").slick({
	slidesToScroll: 1,
	slidesToShow: 3,
	//slidesPerRow: 3,
	centerMode: true,
	centerPadding: '0px',
	responsive:[
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesPerRow: 1,
				slidesToScroll: 1,
				centerMode: false,
				accessibility: false
			}
		}
	]
});